import { FC, PropsWithChildren, createContext, useContext } from "react"
import { useGameLogic } from "@/hooks/useGameLogic"

const GameContext = createContext<ReturnType<typeof useGameLogic> | null>(null)

export const GameProvider: FC<PropsWithChildren> = ({ children }) => {
  const value = useGameLogic()
  return <GameContext.Provider value={value}>{children}</GameContext.Provider>
}

export const useGame = () => {
  const context = useContext(GameContext)
  if (!context) throw new Error("useGame must be used within GameProvider")
  return context
}
